var _path, _polygon, _polygon2, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIskollLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "426 30 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "iskoll_square"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5E7092",
    strokeWidth: 60,
    strokeMiterlimit: 10,
    d: "M695.665,88.565 c52.622,25.55,88.899,79.504,88.899,141.93c0,84.697-66.778,153.799-150.558,157.526c-2.363,0.105-4.739,0.159-7.128,0.159 c-21.771,0-42.513-4.412-61.377-12.392c-56.596-23.938-96.308-79.979-96.308-145.293c0-81.417,61.705-148.422,140.898-156.802"
  })), /*#__PURE__*/React.createElement("g", {
    id: "isdubb"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spets_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 612.1895,
    y1: 381.9912,
    x2: 625.75,
    y2: 381.9912,
    gradientTransform: "matrix(0.9888 0.1492 -0.1492 0.9888 45.8525 -95.9977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "spets",
    fill: "url(#spets_5_)",
    points: "604.212,320.869 591.042,394.073 589.767,426.038 591.385,426.281  603.405,393.102 615.541,322.578  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "spetsblank_1_",
    fill: "#FFFFFF",
    points: "608.836,321.566 601.612,361.62 592.232,394.017 591.075,423.635  602.18,392.443 604.075,362.226 611.414,321.719  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue_handtag_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.9521,
    y1: 186.1152,
    x2: 652.7168,
    y2: 186.1152,
    gradientTransform: "matrix(0.9888 0.1492 -0.1492 0.9888 45.8525 -95.9977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55698D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    style: {
      stopColor: "#808EA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54698D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "blue_handtag_1_",
    fill: "url(#blue_handtag_6_)",
    d: "M595.364,319.896c-0.177-0.082,0.057-0.394,0.11-0.603 c10.471-41.065,1.445-47.231-2.356-56.886c0,0-1.637-0.797,1.188-4.771c14.895-20.955,13.337-20.312,14.345-62.543 c0.84-35.197,14.396-84.386,28.868-115.994c5.024-17.597-6.815-26.464-5.782-31.662c1.034-5.198,1.825-9.173,1.825-9.173 c8.553-4.656,26.287-1.129,26.287-1.129s18.039,2.753,24.508,10.034c0,0-0.604,4.007-1.396,9.248 c-0.79,5.24-14.938,9.566-16.178,27.825c2.892,34.643-1.037,85.514-12.185,118.909c-13.374,40.071-14.621,38.937-7.716,63.703 c1.309,4.695-0.502,4.89-0.502,4.89c-6.851,7.793-17.432,10.533-21.509,52.715c-0.021,0.215,0.092,0.587-0.102,0.605 C611.792,326.268,607.166,325.432,595.364,319.896z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "band_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.3164,
    y1: 326.1377,
    x2: 635.3379,
    y2: 326.1377,
    gradientTransform: "matrix(0.9888 0.1492 -0.1492 0.9888 45.8525 -95.9977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    style: {
      stopColor: "#E4912B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    style: {
      stopColor: "#EBB168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7725,
    style: {
      stopColor: "#E4912B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "band",
    fill: "url(#band_5_)",
    d: "M625.863,315.854c-0.362,2.67-0.693,5.533-0.99,8.604 c-0.021,0.215,0.092,0.587-0.102,0.605c-12.979,1.205-17.605,0.368-29.407-5.168c-0.177-0.082,0.057-0.394,0.11-0.603 c0.759-2.978,1.417-5.773,1.979-8.398c0,0,10.183,3.723,13.709,4.343C614.777,315.873,625.863,315.854,625.863,315.854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "knopp_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.7217,
    y1: 67.5024,
    x2: 652.7168,
    y2: 67.5024,
    gradientTransform: "matrix(0.9888 0.1492 -0.1492 0.9888 45.8525 -95.9977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2121,
    style: {
      stopColor: "#E4912B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5082,
    style: {
      stopColor: "#EBB068"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    style: {
      stopColor: "#E4912B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "knopp",
    fill: "url(#knopp_5_)",
    d: "M634.409,86.197c1.028-2.449,2.067-4.819,3.11-7.097 c5.024-17.597-6.815-26.464-5.782-31.662c1.034-5.198,1.825-9.173,1.825-9.173c8.553-4.656,26.287-1.129,26.287-1.129 s18.039,2.753,24.508,10.034c0,0-0.604,4.007-1.396,9.248c-0.79,5.24-14.938,9.566-16.178,27.825 c0.233,2.808,0.423,5.722,0.567,8.725c0,0-12.746-0.885-16.759-1.709C646.369,90.39,634.409,86.197,634.409,86.197z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "kontur_1_",
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    d: "M595.364,319.896 c-0.177-0.082,0.057-0.394,0.11-0.603c10.471-41.065,1.445-47.231-2.356-56.886c0,0-1.637-0.797,1.188-4.771 c14.895-20.955,13.337-20.312,14.345-62.543c0.84-35.197,14.396-84.386,28.868-115.994c5.024-17.597-6.815-26.464-5.782-31.662 c1.034-5.198,1.825-9.173,1.825-9.173c8.553-4.656,26.287-1.129,26.287-1.129s18.039,2.753,24.508,10.034 c0,0-0.604,4.007-1.396,9.248c-0.79,5.24-14.938,9.566-16.178,27.825c2.892,34.643-1.037,85.514-12.185,118.909 c-13.374,40.071-14.621,38.937-7.716,63.703c1.309,4.695-0.502,4.89-0.502,4.89c-6.851,7.793-17.432,10.533-21.509,52.715 c-0.021,0.215,0.092,0.587-0.102,0.605C611.792,326.268,607.166,325.432,595.364,319.896z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIskollLogo02);
export default __webpack_public_path__ + "static/media/iskoll-logo-02.a8f2a40aec17bd1b46b24991a48560f2.svg";
export { ForwardRef as ReactComponent };